import { createGlobalStyle } from 'styled-components';

export const GlobalFont = createGlobalStyle`
  @import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css");
`;
